import { Component, ChangeDetectorRef } from "@angular/core";

import { SkipWizardService } from "./skip-wizard.service";

@Component({
	selector: "sdp-skip-wizard",
	templateUrl: "./skip-wizard.component.html"
})
export class SkipWizardComponent {
	public isHideWizardChanging = false;
	public hideWizard: boolean;

	constructor(
		private service: SkipWizardService,
		private changeDetector: ChangeDetectorRef
	) {
		this.hideWizard = this.service.getHideWizardFromCurrentUser();
	}

	public async toggleHideWizard() {
		this.isHideWizardChanging = true;
		// passing a parent value to the child and it changes can cause ExpressionChangedAfterItHasBeenCheckedError
		this.changeDetector.detectChanges();
		// await this.apiGatewayService.updateHideWizard(this.hideWizard);
		await this.service.processHideWizard(this.hideWizard);
		this.isHideWizardChanging = false;
		// wait is not an angular event, so we need to fire the angular event changer
		this.changeDetector.detectChanges();
	}
}
